module.exports = __webpack_public_path__ + "static/media/13.5242ba96.jpeg";